import styled from '@emotion/styled';
export { default } from '@emotion/styled';
import cjs from '../../../../node_modules/.pnpm/deepmerge@4.2.2/node_modules/deepmerge/dist/cjs.js';
import default404Image from '../ISO/Components/UI/Images/Default404Image.js';

const createTheme = (customTheme) => {
    const scssVars = customTheme.bootstrap;
    const reactSelectTheme = theme => ({
        ...theme,
        colors: {
            ...theme.colors,
            ...{
                primary: scssVars.inputFocusBorderColor,
                neutral20: scssVars.inputBorderColor
            }
        }
    });
    const reactSelectStyles = {
        valueContainer: provided => ({
            ...provided,
            padding: '0 0.75rem'
        }),
        singleValue: provided => ({
            ...provided,
            color: scssVars.inputColor
        }),
        option: (provided, { isSelected, isFocused }) => ({
            ...provided,
            cursor: 'pointer',
            color: isSelected ? scssVars.white : scssVars.inputColor,
            // eslint-disable-next-line no-nested-ternary
            backgroundColor: isSelected ? scssVars.gray600 : isFocused ? scssVars.gray200 : undefined
        }),
        control: (provided, state) => ({
            ...provided,
            borderWidth: scssVars.borderWidth,
            boxShadow: state.isFocused ? scssVars.inputFocusBoxShadow : 'none',
            borderColor: scssVars.inputBorderColor,
            minHeight: 'auto'
        }),
        container: provided => ({
            ...provided,
            borderWidth: scssVars.borderWidth,
            boxShadow: 'none'
        }),
        placeholder: provided => ({
            ...provided,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            color: scssVars.primary
        }),
        menuPortal: provided => ({
            ...provided,
            zIndex: 1100
        })
    };
    const baseTheme = {
        bootstrap: scssVars,
        reactSelectTheme,
        reactSelectStyles,
        useCalenderIcon: false,
        mobileBreakpoint: 1024,
        searchCriteriaDisplay: {
            color: scssVars.primary,
            backgroundColor: scssVars.gray200
        },
        paxSelectionOptions: {
            withIcon: true,
            shortTitle: true,
            staticTitle: false
        },
        placeholderImages: {
            hotel: default404Image,
            room: default404Image,
            flight: default404Image,
            extra: default404Image,
            dining: default404Image,
            rentalCar: default404Image,
            transfer: default404Image,
            package: default404Image,
            camper: default404Image
        },
        images: {
            logo: '',
            home: '',
            hotel: ''
        }
    };
    return { ...cjs(baseTheme, customTheme) };
};

export { createTheme };
//# sourceMappingURL=theme.js.map
